import { render, staticRenderFns } from "./account-withdrawal-number.vue?vue&type=template&id=4b8c8024&scoped=true&"
import script from "./account-withdrawal-number.vue?vue&type=script&lang=js&"
export * from "./account-withdrawal-number.vue?vue&type=script&lang=js&"
import style0 from "./account-withdrawal-number.vue?vue&type=style&index=0&id=4b8c8024&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8c8024",
  null
  
)

component.options.__file = "account-withdrawal-number.vue"
export default component.exports